.content {
  max-height: 288px;
  max-width: 300px;
}

.list {
  display: flex;
  flex-direction: column;
}

.item {
  margin-bottom: var(--space-2xs);

  &:last-child {
    margin-bottom: 0;
  }
}
